import React from 'react';
import { Reveal } from './ui/Reveal';
import { CtaButton } from './ui/CtaButton';
import { BONUS_TOTAL, OFFER_ANCHOR, PRICE, PRODUCT_NAME } from '../data/content';
export function FinalCTA() {
  return <section aria-labelledby="cierre" className="bg-noche" data-id="element-55" data-mp="c70xva6rjfok">
      <div className="mx-auto max-w-xl px-3 py-5 text-center sm:px-5" data-id="element-56" data-mp="c4fuuhuqatp8">
        <h2 id="cierre" className="font-display text-[1.6rem] uppercase leading-none text-oro sm:text-4xl" data-id="element-57" data-mp="83m83rt0vkxx">
          Una última oportunidad
        </h2>
        <p className="mx-auto mt-2 max-w-xl text-sm leading-snug text-white/90" data-id="element-58" data-mp="h52gju0a1czi">
          Podés seguir perdiendo horas buscando actividades, preparando
          evaluaciones y reuniendo contenidos de Lengua y Literatura en
          diferentes lugares. O podés comenzar hoy con un sistema organizado
          que reúne teoría, ejercicios, guías de lectura y recursos docentes en
          un solo lugar.
        </p>
        <p className="mx-auto mt-1.5 max-w-xl font-sub text-sm font-bold leading-snug text-white" data-id="element-59" data-mp="zy6dbo8sk5yc">
          No necesitás seguir preparando cada material desde cero.{' '}
          <span className="text-oro" data-id="element-60" data-mp="2h4sq6i8l9tub">
            Necesitás una base organizada que te permita enseñar, estudiar y
            avanzar con mayor facilidad.
          </span>
        </p>

        <Reveal className="mt-3 rounded-2xl border-4 border-dashed border-oro bg-white p-3 text-noche" data-id="element-61" data-mp="2r2786ma5uqoq">
          <p className="font-sub text-sm font-extrabold uppercase leading-tight text-noche" data-id="element-62" data-mp="2v4akte8kg1bl">
            {PRODUCT_NAME}
          </p>
          <p className="mt-1 inline-block rounded-md bg-oro px-2 py-0.5 font-display text-2xl uppercase leading-tight text-noche" data-id="element-63" data-mp="300sn87gfbnkr">
            6 Tomos + 5 Bonos
          </p>
          <p className="mt-1 text-xs font-semibold text-noche-dark/80 sm:text-sm" data-id="element-64" data-mp="39rdipm0swbzg">
            Valor de los bonos:{' '}
            <span className="line-through decoration-red-600 decoration-2" data-id="element-65" data-mp="3et2syzg78lmh">{BONUS_TOTAL}</span>
          </p>
          <p className="mx-auto mt-1.5 w-fit rounded-xl border-2 border-noche bg-oro px-3 py-1 font-display text-5xl leading-none text-noche sm:text-6xl" data-id="element-66" data-mp="3itd3mpexs07o">
            <span className="text-2xl sm:text-3xl" data-id="element-67" data-mp="1eq1pc6j88vfw">Hoy:</span> {PRICE}
          </p>

          <CtaButton href={OFFER_ANCHOR} size="lg" className="mt-3" data-id="element-68" data-mp="1sh6shilt05uz">
            🚀 Sí, quiero comenzar ahora
          </CtaButton>

          <p className="mt-2.5 text-xs font-semibold text-noche-dark/80" data-id="element-69" data-mp="1np59ldu4rgvz">
            Acceso Inmediato • Entrega Digital • Garantía de 7 Días
          </p>
        </Reveal>
      </div>
    </section>;
}